import { alignLeftCellStyle, alignCenterCellStyle } from '@common/cellStyles';
import {
  amountColumnDefinition,
  commentsColumnDefinition,
} from '../shared/columnDefinitions';

export default returnToprovisionColumnDefs => [  //eslint-disable-line
  {
    headerName: 'LEID',
    field: 'leid',
    width: 100,
    minWidth: 90,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Tax Code',
    field: 'cdr_number',
    width: 100,
    minWidth: 90,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Reporting Period',
    field: 'reporting_period',
    width: 100,
    minWidth: 70,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'ME Code',
    field: 'me_code',
    width: 120,
    minWidth: 90,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Ledger',
    field: 'ledger',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Currency',
    field: 'curr',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Chart',
    field: 'local_chart',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Posting Local Acct',
    field: 'postingAcct',
    width: 120,
    minWidth: 100,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Trading Partner Leid',
    field: 'tradingPartner',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Trading Partner Tax Code',
    field: 'tp_cdr_number',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Trading Partner Reporting Period',
    field: 'tp_rpt_pd',
    width: 100,
    minWidth: 120,
    ...alignCenterCellStyle,
  },
  { ...amountColumnDefinition },
  {
    headerName: 'SchdM Template ID',
    field: 'schdmTemplateId',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'SchdM User Desc',
    field: 'schdmTemplateDesc',
    width: 150,
    minWidth: 150,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'SchdM Type',
    field: 'schdMType',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'SchdM Source',
    field: 'schdMSource',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'TBBS Acct',
    field: 'tbbsAcct',
    width: 120,
    minWidth: 100,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Roll Forward Next Year',
    field: 'rollFwdNextYear',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Provision YN',
    field: 'schdMProvisonYorN',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Project',
    field: 'project',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Project Step',
    field: 'projectStep',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Base Line YN',
    field: 'baseLineYorN',
    width: 120,
    minWidth: 100,
    ...alignCenterCellStyle,
  },
  { ...commentsColumnDefinition, headerName: 'Comments' },
  {
    headerName: 'Trading Partner ME',
    field: 'tradingPartnerME',
    width: 100,
    minWidth: 90,
    ...alignCenterCellStyle,
  },
];
